import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const DialogErrorNims = ({ visibleDialog, selectedLote, setVisibleDialog, downloadExcelErrors }) => {
    const errorNims = selectedLote?.error_nims || [];

    const errorNimsData = errorNims.map((nim, index) => ({
        id: index + 1,
        nim
    }));


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    return (
        <Dialog
            header={`Errores en el PDF - ${selectedLote?.name_company || ""}`}
            visible={visibleDialog}
            onHide={() => setVisibleDialog(false)}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1.2rem',
            }}
            modal
            closable
            dismissableMask={false}
            blockScroll
            className="medium-dialog"    
        >
            {errorNims.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px 0', fontSize: '1rem', color: '#555' }}>
                    <p>No se encontraron NIMs con error.</p>
                </div>
            ) : (
                <>
                    <div style={{ position: 'relative', marginBottom: '10px', height: '30px' }}>
                        <button
                            className="p-button p-button-success"
                            onClick={() => downloadExcelErrors(selectedLote)}
                            title="Exportar a Excel"
                            style={{
                                padding: '5px',
                                width: '30px',
                                height: '30px',
                                minWidth: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.9rem',
                                position: 'absolute',
                                left: 0,
                                top: 0
                            }}
                        >
                            <i className="pi pi-file-excel" style={{ fontSize: '1rem' }}></i>
                        </button>

                        <p style={{
                            fontWeight: "bold",
                            fontSize: '1rem',
                            color: '#333',
                            textAlign: 'center',
                            margin: 0,
                            lineHeight: '30px'
                        }}>
                            Total de errores: {errorNims.length}
                        </p>
                    </div>



                    <DataTable
                        value={errorNimsData}
                        paginator
                        rows={10}
                        scrollable
                        scrollHeight="300px"
                        className="p-datatable-sm p-datatable-striped"
                        responsiveLayout="scroll"
                        style={{ marginTop: '10px' }}
                        emptyMessage="No hay NIMs con error"
                    >
                        <Column 
                            field="id" 
                            header="#" 
                            headerStyle={headerStyle} 
                            style={{ ...cellStyle, width: '50px' }} 
                        />
                        <Column 
                            field="nim" 
                            header="NIM" 
                            headerStyle={headerStyle} 
                            style={cellStyle} 
                        />
                    </DataTable>

                    <p style={{ fontSize: '0.9rem', color: '#ff7300ff', marginTop: '10px', textAlign: 'center' }}>
                        Estos NIMs no se pudieron generar correctamente en el PDF para la impresión.
                    </p>
                </>
            )}
        </Dialog>
    );
};
